import { render, staticRenderFns } from "./SingleChoice.vue?vue&type=template&id=c3952440&scoped=true&"
import script from "./SingleChoice.vue?vue&type=script&lang=js&"
export * from "./SingleChoice.vue?vue&type=script&lang=js&"
import style0 from "./SingleChoice.vue?vue&type=style&index=0&id=c3952440&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3952440",
  null
  
)

export default component.exports